import { render, staticRenderFns } from "./registZCYL.vue?vue&type=template&id=2237d500"
import script from "./registZCYL.vue?vue&type=script&lang=js"
export * from "./registZCYL.vue?vue&type=script&lang=js"
import style0 from "./registZCYL.vue?vue&type=style&index=0&id=2237d500&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports